package com.milta.feature.auth.domain.entity

enum class OAuthProvider(val apiValue: String) {
    GOOGLE("Google"),
    APPLE("Apple"),
}
